import { jsx as _jsx } from "react/jsx-runtime";
import { getDataComponentName, } from "../ui-interfaces";
import { Box } from "../Box";
export const ContainerRelative = ({ dataComponentName, sx, show = true, fullHeight = false, children = null, }) => {
    if (!show)
        return null;
    return (_jsx(Box, { dataComponentName: getDataComponentName(dataComponentName, "ContainerRelative"), sx: Object.assign(Object.assign({}, sx), { position: "relative" }), fullHeight: fullHeight, children: children }));
};
